/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import {
  PLUGIN_FONT_SIZE_RANGE,
  PLUGIN_LETTER_SPACING_RANGE,
} from '@sportninja/common/features/account/apiAccess'
import { NumberField, TextField } from '../../../components/FormikField'
import {
  GOOGLE_FONTS_URL,
  PLUGIN_BASE_FONT_SIZE,
} from '../../constants/pluginSettings'
import { SettingsCard } from './SettingsCard'

/** The font fields' hint, linking to Google Fonts in a new tab. */
const FontHint = () => (
  <>
    Any{' '}
    <a
      href={GOOGLE_FONTS_URL}
      target='_blank'
      rel='noopener noreferrer'
      css={linkStyle}
    >
      Google Fonts
    </a>{' '}
    family, typed as Google lists it, e.g. Open Sans
  </>
)
const FONT_SIZE_HINT = `${PLUGIN_FONT_SIZE_RANGE.min}–${PLUGIN_FONT_SIZE_RANGE.max} px`
const LETTER_SPACING_HINT = `${PLUGIN_LETTER_SPACING_RANGE.min} to ${PLUGIN_LETTER_SPACING_RANGE.max} px, steps of ${PLUGIN_LETTER_SPACING_RANGE.step}`
const DEFAULT_PLACEHOLDER = capitalizeWords('Default')

/** Body text (font, size, letter spacing) and headings (font, letter spacing). */
export const ThemeFonts = () => (
  <>
    <SettingsCard
      title='Body text'
      description='Paragraphs, labels, tables and buttons'
    >
      <TextField
        name='branding.fontFamily'
        label={capitalizeWords('Body Font')}
        placeholder={DEFAULT_PLACEHOLDER}
        hint={<FontHint />}
        emptyValue='unset'
      />
      <NumberField
        name='branding.fontSize'
        label={capitalizeWords('Body Font Size')}
        placeholder={PLUGIN_BASE_FONT_SIZE}
        hint={FONT_SIZE_HINT}
        emptyValue='unset'
      />
      <NumberField
        name='branding.letterSpacing'
        label={capitalizeWords('Body Letter Spacing')}
        placeholder='0'
        hint={LETTER_SPACING_HINT}
        emptyValue='unset'
      />
    </SettingsCard>
    <SettingsCard
      title='Headings'
      description='Titles, tabs and other uppercase display text'
    >
      <TextField
        name='branding.headingFontFamily'
        label={capitalizeWords('Heading Font')}
        placeholder={DEFAULT_PLACEHOLDER}
        hint={<FontHint />}
        emptyValue='unset'
      />
      <NumberField
        name='branding.headingLetterSpacing'
        label={capitalizeWords('Heading Letter Spacing')}
        placeholder={DEFAULT_PLACEHOLDER}
        hint={LETTER_SPACING_HINT}
        emptyValue='unset'
      />
    </SettingsCard>
  </>
)

const linkStyle = css`
  color: ${colors.PRIMARY};
  text-decoration: underline;
  &:hover {
    color: ${colors.PRIMARY};
    opacity: 0.85;
  }
`
